export default {
  labels: {
    open: 'Show items',
    collapse: 'Close items',
    in_stock: 'In Stock',
    out_of_stock: 'Out of Stock',
  },
  list: {
    name: 'Menu item',
    price: 'Price',
    is_available: 'IN/OUT OF STOCK',
  },
};
